// eslint-disable-next-line no-unused-vars
export enum SortDirectionOptions {
  ascend = 'ASC',
  descend = 'DESC',
  none = 'NONE'
}

export enum Days {
  monday = 'MONDAY',
  tuesday = 'TUESDAY',
  wednesday = 'WEDNESDAY',
  thursday = 'THURSDAY',
  friday = 'FRIDAY',
  saturday = 'SATURDAY',
  sunday = 'SUNDAY'
}
